import { useMemo } from 'react'
import { bindActionCreators, Dispatch } from 'redux'
import { createAction } from '@reduxjs/toolkit'

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace ApisActions {
  export enum Type {
    LOGIN = 'LOGIN',
    LOGOUT = 'LOGOUT',
  }
  export const login = createAction<{ host: string; username: string; password: string }>(Type.LOGIN)
  export const logout = createAction<Record<string, never>>(Type.LOGOUT)
}

export type ApisActions = Omit<typeof ApisActions, 'Type'>
export const useApisActions = (dispatch: Dispatch) => {
  const { Type, ...actions } = ApisActions
  return useMemo(() => bindActionCreators(actions as any, dispatch), [dispatch]) as ApisActions
}
